import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/prompts/api' 
  : 'http://localhost/prompts/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const promptsAPI = {
  getAll: (params = {}) => api.get('/prompts', { params }),
  getById: (id) => api.get(`/prompts/${id}`),
  create: (data) => api.post('/prompts', data),
  update: (id, data) => api.put(`/prompts/${id}`, data),
  delete: (id) => api.delete(`/prompts/${id}`),
};

export const votesAPI = {
  vote: (data) => api.post('/votes', data),
  getVotes: (promptId) => api.get(`/votes/${promptId}`),
};

export const adminAPI = {
  login: (username, password) => api.post('/admin', { username, password }),
  logout: (session) => api.post('/admin/logout', {}, {
    headers: { 'X-Admin-Session': session }
  }),
  getAll: (session) => api.get('/admin/prompts', {
    headers: { 'X-Admin-Session': session }
  }),
  update: (id, data, session) => api.put(`/admin/prompts/${id}`, data, {
    headers: { 'X-Admin-Session': session }
  }),
  delete: (id, session) => api.delete(`/admin/prompts/${id}`, {
    headers: { 'X-Admin-Session': session },
    data: { action: 'delete' }
  }),
  restore: (id, session) => api.delete(`/admin/prompts/${id}`, {
    headers: { 'X-Admin-Session': session },
    data: { action: 'restore' }
  }),
  deletePermanently: (id, session) => api.delete(`/admin/prompts/${id}`, {
    headers: { 'X-Admin-Session': session },
    data: { action: 'delete_permanently' }
  }),
  bulkDelete: (ids, session) => api.delete('/admin/prompts', {
    headers: { 'X-Admin-Session': session },
    data: { action: 'delete', ids }
  }),
  bulkRestore: (ids, session) => api.delete('/admin/prompts', {
    headers: { 'X-Admin-Session': session },
    data: { action: 'restore', ids }
  }),
  bulkDeletePermanently: (ids, session) => api.delete('/admin/prompts', {
    headers: { 'X-Admin-Session': session },
    data: { action: 'delete_permanently', ids }
  }),
  bulkUpdateCategory: (ids, category, session) => api.delete('/admin/prompts', {
    headers: { 'X-Admin-Session': session },
    data: { action: 'update_category', ids, category }
  }),
};

export const favoritesAPI = {
  add: (data) => api.post('/favorites', data),
  remove: (promptId, username) => api.delete(`/favorites/${promptId}`, {
    params: { username }
  }),
  getAll: (username) => api.get('/favorites', { params: { username } }),
};

export const exportAPI = {
  export: (format, username = null) => {
    const params = username ? { format, username } : { format };
    return api.get('/export', { params, responseType: 'blob' });
  },
};

export const analyticsAPI = {
  getOverview: () => api.get('/analytics?type=overview'),
  getPopular: () => api.get('/analytics?type=popular'),
  getTrending: () => api.get('/analytics?type=trending'),
  getCategories: () => api.get('/analytics?type=categories'),
};
